// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"e337211b","279":"31e0d11f","387":"61626181","390":"5b5f23ab","415":"0c052e9e","638":"4378f826","723":"019e34f3"}[chunkId] + ".chunk.js";
};